import React from 'react';
import { StyleSheet, View, ViewStyle } from 'react-native';
import CountryFlag from 'react-native-country-flag';
import { Country } from '@oolio-group/design-common';

interface FlagProps {
  /** ISO country code (e.g. `AU`); matched case-insensitively. */
  code: Country['code'];
  /** Height of the flag image in px. Defaults to 20. */
  size?: number;
  containerStyle?: ViewStyle | ViewStyle[];
}

// NOTE: react-native-country-flag renders from https://flagcdn.com, so flags
// are blank on an offline or firewalled CDS. Bundle the images locally if that
// becomes a problem in the field.
const Flag: React.FC<FlagProps> = ({ code, size = 20, containerStyle }) => (
  <View style={[styles.container, containerStyle]}>
    <CountryFlag isoCode={code.toLowerCase()} size={size} />
  </View>
);

const styles = StyleSheet.create({
  // eslint-disable-next-line react-native/no-color-literals
  container: {
    width: 32,
    height: 20,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 2,
    overflow: 'hidden',
  },
});

export default Flag;
